export const MAP_TYPES = {
  MAPS: 'maps',
  SAMPLING: 'sampling',
  ALL: 'all',
} as const;

export type MapType = (typeof MAP_TYPES)[keyof typeof MAP_TYPES];
